import script from "./CategBreadcrumb.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategBreadcrumb.vue?vue&type=script&setup=true&lang=ts"

import "../../assets/css/categ-breadcrumb.css?vue&type=style&index=0&id=4e24e4ec&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e24e4ec"]])

export default __exports__